/**
 * 链接对话框配置
 * 用于控制不同编辑器实例是否使用自定义链接对话框
 */

export interface LinkDialogConfig {
  /** 是否启用自定义链接对话框 */
  useCustomLinkDialog: boolean;
  /** 配置描述 */
  description?: string;
}

/**
 * 预定义的链接对话框配置
 */
export const LinkDialogConfigs = {
  /** 默认配置：使用自定义对话框 */
  default: {
    useCustomLinkDialog: true,
    description: 'Default configuration with custom link dialog'
  } as LinkDialogConfig,

  /** 原生配置：使用TinyMCE原生对话框 */
  native: {
    useCustomLinkDialog: false,
    description: 'Use TinyMCE native link dialog'
  } as LinkDialogConfig,

  /** 签名编辑器配置：使用自定义对话框 */
  signature: {
    useCustomLinkDialog: true,
    description: 'Custom link dialog for signature editor'
  } as LinkDialogConfig,
} as const;

/**
 * 获取链接对话框配置
 */
export const getLinkDialogConfig = (configName: keyof typeof LinkDialogConfigs = 'default'): LinkDialogConfig => {
  return LinkDialogConfigs[configName];
};

/**
 * 为编辑器配置添加链接对话框设置
 */
export const withLinkDialogConfig = (
  editorConfig: Record<string, any>,
  config: LinkDialogConfig = LinkDialogConfigs.default
): Record<string, any> => {
  return {
    ...editorConfig,
    useCustomLinkDialog: config.useCustomLinkDialog,
  };
};
